import React, { useEffect, useState } from "react";
import {
  MenuItem,
  Pagination,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import InfoIcon from "@mui/icons-material/Info";
import { useDispatch, useSelector } from "react-redux";
import AllApis from "app/Apis/apis";
import { Axios } from "index";
import Swal from "sweetalert2";
import { formatDate } from "app/pages/Component/Function/formatDate";
import ViewSalesModel from "../ViewSalesModel";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { getAllSalesOrders } from "app/redux/actions/ConfirmSalesOrders";
import RefundModel from "../Refund/RefundModal";

export default function SalesTable({
  tabletype,
  type,
  page,
  setPage,
  search,
  filter,
  sort,
  setSort,
  sortBy,
  setSortBy,
}) {
  const [openModel, setOpenModel] = useState(false);
  const [refundmodel, setRefundModel] = useState(false);

  const { TotalPage, confirmSales } = useSelector(
    (state) => state?.salesOrderReducer
  );
  const [orderDetails, setOrderDetails] = useState({});

  const dispatch = useDispatch();
  const handleItemAction = (menuItem) => {
    switch (menuItem.action) {
      case "view":
        setOpenModel(true);
        setOrderDetails(menuItem?.data?.current_data);
        break;
      case "view_refund":
        setOrderDetails(menuItem?.data?.current_data?.refund_id[0]);
        setRefundModel(true);
        break;
      default:
      // navigate(`/dashboard/users`);
    }
  };

  const handleSort = (property) => {
    const sortValue = sort == "asc" ? "desc" : "asc";
    setSort(sort == "asc" ? "desc" : "asc");
    setSortBy(property);
    setPage(1);
    dispatch(getAllSalesOrders(search, sortValue, property, page, filter()));
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: "#7352C7", color: "white" }}>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "160px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.sales_order_no")}
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Sales Order No
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
                color: "white",
              }}
            >
              Sales Order Date
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "120px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.order_no")}
                direction={sort}
                sx={{
                  color: "white",
                  width: "100%",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Order No
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort("current_data.customer_details.bill_to.gst_no")
                }
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                GST No
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort(
                    "current_data.customer_details.bill_to.address.city"
                  )
                }
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                City
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() =>
                  handleSort(
                    "current_data.customer_details.bill_to.address.state"
                  )
                }
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                State
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.total_weight")}
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Total Weight
              </TableSortLabel>
            </TableCell>
            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
              }}
            >
              <TableSortLabel
                onClick={() => handleSort("current_data.total_amount")}
                direction={sort}
                sx={{
                  color: "white",
                  "&:hover": { color: "white" },
                  "&.MuiTableSortLabel-root.Mui-active": {
                    color: "white", // Set the color for the active state
                  },
                }}
              >
                Totol Amount
              </TableSortLabel>
            </TableCell>

            <TableCell
              sx={{
                textAlign: "left",
                minWidth: "150px",
                verticalAlign: "middle",
                color: "white",
                position: "sticky",
                right: 0,
                zIndex: 1,
                bgcolor: "#7352C7",
                height: "58px",
              }}
            >
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {confirmSales?.map((row, i) => {
            return (
              <TableRow>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.sales_order_no}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {formatDate(row?.current_data?.sales_order_date)}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.order_no}
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.gst_no}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.address?.city}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                    textTransform: "capitalize",
                  }}
                >
                  {row?.current_data?.customer_details?.bill_to?.address?.state}
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  {row?.current_data?.total_weight}
                </TableCell>
                <TableCell
                  sx={{
                    textAlign: "left",
                  }}
                >
                  ₹ {row?.current_data?.total_amount?.toFixed(2)}
                </TableCell>

                <TableCell
                  sx={{
                    textAlign: "left",
                    position: "sticky",
                    right: 0,
                    zIndex: 1,
                    bgcolor: "white",
                  }}
                >
                  <JumboDdMenu
                    icon={<MoreHorizIcon />}
                    menuItems={[
                      {
                        icon: <VisibilityRoundedIcon />,
                        title: "View Sales Order",
                        action: "view",
                        data: row,
                        visibility: true,
                      },
                      {
                        icon: <InfoIcon />,
                        title: "View Refund Details",
                        action: "view_refund",
                        data: row,
                        visibility: row?.current_data?.refund_id.length != 0,
                      },
                    ].filter((ele) => ele.visibility == true)}
                    onClickCallback={handleItemAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>

        {openModel && (
          <ViewSalesModel
            open={openModel}
            setOpen={setOpenModel}
            selectedRow={orderDetails}
            setSelectedRow={setOrderDetails}
          />
        )}
        {refundmodel && (
          <RefundModel
            open={refundmodel}
            setOpen={setRefundModel}
            selectedRow={orderDetails}
          />
        )}
      </Table>
      <Pagination
        count={TotalPage || 1}
        page={page}
        onChange={handleChangePage}
        sx={{
          position: "sticky",
          bottom: 0,
          left: 0,
          p: 1,
          backgroundColor: "white",
          borderTop: "1px solid #ddd",
        }}
      />
    </TableContainer>
  );
}
